import script from "./columns.vue?vue&type=script&setup=true&lang=js"
export * from "./columns.vue?vue&type=script&setup=true&lang=js"

import "./columns.vue?vue&type=style&index=0&id=3bbe5588&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bbe5588"]])

export default __exports__